exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js??ref--4-1!../../../node_modules/postcss-loader/index.js??postcss!../common.css"), "");
exports.push([module.id, "@import url(https://unpkg.com/bootstrap@3.3.7/dist/css/bootstrap.min.css);", ""]);

// module
exports.push([module.id, "/* .ng-valid[required], .ng-valid.required  {\n    border-left: 2px solid #42A948; \n  }\n  \n  .ng-invalid:not(form)  {\n    border-left: 1px solid #a94442;  \n  } */\n\n/*  \n.example-form {\n  min-width: 150px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.example-full-width {\n  width: 100%;\n} */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/auth/auth.component.css
// module id = ../../../../../src/app/auth/auth.component.css
// module chunks = main